// Team carousel: a Swiper whose slides rotate with their progress through the arc.
import { onReady } from '../utils/ready.js';

var STEP = -30.865;

function setRot(s) {
  for (var i = 0; i < s.slides.length; i++) {
    s.slides[i].style.setProperty('--disc-rot', (s.slides[i].progress * STEP).toFixed(2) + 'deg');
  }
}

export function initTeamCarousel() {
  onReady(function init() {
    var el = document.querySelector('.team__carousel');
    if (!el) return;
    if (!window.Swiper) {
      setTimeout(init, 50);
      return;
    }
    new Swiper(el, {
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: true,
      initialSlide: 2,
      speed: 600,
      watchSlidesProgress: true,
      navigation: {
        prevEl: '.team__slider .slider-nav__btn:last-child',
        nextEl: '.team__slider .slider-nav__btn:first-child',
      },
      on: {
        progress: function (s) {
          setRot(s);
        },
        setTransition: function (s, d) {
          for (var i = 0; i < s.slides.length; i++) {
            var disc = s.slides[i].querySelector('.disc-team');
            if (disc) disc.style.transitionDuration = d + 'ms';
          }
        },
      },
    });
  });
}
